export function WhatsAppIcon({ className = "", size = 20 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
      fill="currentColor"
    >
      <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.045 2.264v.114c-.015.99.472 1.977 1.033 2.78 1.06 1.548 2.24 2.845 3.94 3.687.947.472 2.55 1.017 3.611 1.017.514 0 2.24-.13 2.626-.6.13-.152.257-.402.257-.6 0-.115-.023-.243-.043-.358-.143-.472-1.947-1.375-2.36-1.375zM16.257 3.958c-6.663 0-12.075 5.412-12.075 12.075 0 2.373.68 4.66 1.947 6.632L4 28l5.446-1.85c1.86 1.115 4.008 1.706 6.223 1.706 6.664 0 12.076-5.412 12.076-12.075 0-6.664-5.412-12.076-12.076-12.076v.253zm0 22.147c-1.99 0-3.94-.588-5.617-1.706L7.42 25.51l.973-3.146a10.09 10.09 0 0 1-1.86-5.848c0-5.615 4.573-10.188 10.19-10.188 5.616 0 10.19 4.573 10.19 10.188 0 5.616-4.574 10.19-10.19 10.19z"/>
    </svg>
  );
}

export default WhatsAppIcon;
